import { connectProblem } from "./errors.js";
import { connectFailure, connectSuccess } from "./outcomes.js";
export async function* coordinatedSavedViewPages(executeView, releaseQueryCursor, input, options = {}) {
    const { offset: requestedOffset, limit: requestedLimit, cursor: requestedCursor, ...criteria } = input;
    let offset = nonNegativeInteger(requestedOffset, 0);
    const firstPageSize = positiveInteger(options.firstPageSize ?? requestedLimit, 200);
    const pageSize = positiveInteger(options.pageSize ?? requestedLimit, 1_000);
    let cursor = requestedCursor;
    let cursorMode = requestedCursor !== undefined;
    let cursorToRelease = requestedCursor;
    let loaded = 0;
    let pageNumber = 0;
    try {
        while (!options.signal?.aborted) {
            const pageCursor = cursor;
            const outcome = await executeView({
                ...criteria,
                limit: pageNumber === 0 ? firstPageSize : pageSize,
                ...(cursorMode && pageCursor ? { cursor: pageCursor } : { offset })
            }, {
                signal: options.signal,
                timeoutMs: options.pageTimeoutMs,
                coordination: { ...options.coordination, coalesce: false }
            });
            if (!outcome.ok) {
                yield outcome;
                return;
            }
            const result = outcome.value;
            const returnedCursor = result.meta.cursor;
            if (returnedCursor) {
                cursorMode = true;
                cursor = returnedCursor;
                cursorToRelease = returnedCursor;
            }
            else if (cursorMode) {
                cursor = undefined;
                cursorToRelease = pageCursor;
            }
            if (cursorMode && result.meta.hasMore && !returnedCursor) {
                yield connectFailure(connectProblem("invalid_operation_response", "The collection authority omitted the cursor required for the next saved-view page."));
                return;
            }
            loaded += result.results.length;
            const complete = !result.meta.hasMore || result.results.length === 0;
            const page = {
                ...result,
                page: pageNumber,
                offset,
                loaded,
                complete,
                ...(returnedCursor ? { cursor: returnedCursor } : {})
            };
            options.onProgress?.(page);
            yield connectSuccess(page, outcome.diagnostics);
            if (complete)
                return;
            offset += result.results.length;
            pageNumber += 1;
        }
    }
    finally {
        if (cursorMode && cursorToRelease)
            await releaseQueryCursor(cursorToRelease);
    }
}
function nonNegativeInteger(value, fallback) {
    return typeof value === "number" && Number.isFinite(value)
        ? Math.max(0, Math.floor(value))
        : fallback;
}
function positiveInteger(value, fallback) {
    return typeof value === "number" && Number.isFinite(value) && value > 0
        ? Math.floor(value)
        : fallback;
}
